<template>
  <!-- /*讲故事*/-->
  <div class="resistance">
    <div class="contentnr">
      <div class="content">
        <div class="resistance-character clearfix">
          <swiper :options="swiperOption" ref="mySwiper" v-if="screentowdata.length>0">
            <swiper-slide v-for="(item,index)  in screentowdata" class="enlarge" :key="index">
              <img v-lazy="item.basicThumbnail" @click="handleHerf(item.basicId)">
              <div class="swiper-slide-title ">
                <div class="product-buyer-name" style="font-size: 16px" v-html="item.basicTitle"
@click="handleHerf(item.basicId)">
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <div class="resistance-right">
            <div class="resistance-content-right">
              <h3  v-html="title" :title="title"></h3>
              <p v-html="content" style="text-indent: 2em;">
                {{content}}
              </p>
              <span @click="handleHerf()">阅读全文</span>
            </div>
          </div>
        </div>
        <div style="width: 100%;display: flex;flex-direction: column;align-items: center">
          <h2 class="zsjjzj">总书记祭扫足迹</h2>
          <div class="resistance-content clearfix">
            <div class="button-prev"></div>
            <swiper :options="swiperOption2" ref="mySwiper2" v-if="ButtomList.length>0">
              <swiper-slide v-for="(item,index)  in ButtomList" class="resistance-content-left" :key="index">
                <div class="resistance-content-img enlarge">
                  <img  v-lazy="item.basicThumbnail" @click="handleHerf(item.basicId)">
                  <div class="resistance-content-img-text " :title="item.basicTitle"  v-html="item.Title||item.basicTitle"></div>
                </div>
                <div class="resistance-content-text cont cont-4" :title="item.basicTitle"  @click="handleHerf(item.basicId)" v-html="item.Roundup||item.basicRoundup">
                </div>
              </swiper-slide>
            </swiper>
            <div class="button-next"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import util from '@/assets/js/util'
  /*总书记讲历史*/
  import {getjlsdata, getzsjdata} from '@/api/generalsecretary.js'

  export default {
    name: "resistance",
    data() {
      let self = this
      return {
        screentowdata: [],
        isdetails: true,
        ButtomList: [],
        imgindex: 0,
        swiperOption: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: "bullets"
          },
          notNextTick: true,
          initialSlide: 0,
          direction: 'horizontal',
          autoplay: {
            delay: 2000,
            stopOnLastSlide: false,
            disableOnInteraction: true
          },
          on: {
            slideChangeTransitionStart: function () {
              self.imgindex = this.activeIndex
              self.handleTab(self.imgindex)
            },
          },
          loopedSlides: 1,
          loopAdditionalSlides: 0,
          slidesPerView: 1,
          observer: true,
          observeParents: true
        },
        swiperOption2: {
          pagination: {
            el: '.swiper-pagination2',
          },
          notNextTick: true,
          initialSlide: 0,
          direction: 'horizontal',
          autoplay: {
            delay: 1500,
            stopOnLastSlide: false,
            disableOnInteraction: true
          },
          navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
          },
          loopedSlides: 4,
          loopAdditionalSlides: 0,
          slidesPerView: 4,
          spaceBetween: 10,
          watchSlidesVisibility: true,
          observer: true,
          observeParents: true
        },
        title: '',
        content: '',
        img: '',
        id: ''
      }
    },
    mounted() {
      this.$on('bridge', (val) => {
        /*初始化取json数据*/
        if (this.screentowdata.length == 0 && this.ButtomList == 0) {
          if (util.isEmpty(this.screentowdata)) {
            getjlsdata().then(res => {
              if (res.length > 0) {
                if (!util.isEmpty(res) && this.screentowdata) {
                  this.screentowdata = res.slice(0, 5);
                  this.handleTab(0)
                } else {
                  console.log('没有数据')
                  this.swiper.slideTo(1, 1000, false)
                }
              }
            }).catch((err) => {
              console.log(err, "4")
            })
          }
          this.handleButtomList()
        }
      });
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      },
      swiper2() {
        return this.$refs.mySwiper2.swiper
      }
    },
    methods: {
      handleButtomList() {
        let width = $('html').width()
        if (util.isEmpty(this.ButtomList)) {
          getzsjdata().then(res => {
            if (res.length > 0) {
              if (!util.isEmpty(res) && this.ButtomList) {
                this.ButtomList = res
                this.ButtomList.forEach((item)=>{
                  if(item.basicRoundup.length>28){
                    item.Roundup= item.basicRoundup.substring(0,28 )+"...."
                  }
                  if(width<=1366){
                    if(item.basicTitle.length>10){
                      item.Title = item.basicTitle.substring(0,10)+"...."
                    }
                  }else {
                    if(item.basicTitle.length>25){
                      item.Title = item.basicTitle.substring(0,25)+"...."
                    }
                  }
                })
              } else {
                console.log('没有数据')
              }
            }
          }).catch((err) => {
            console.log(err, "4")
          })
        }
      },
      handleTab(index) {
        let width = $('html').width()
        if (this.screentowdata.length > 0) {
          this.title = this.screentowdata[index].basicTitle;
          if(width<=1366){
            this.content = this.screentowdata[index].basicRoundup.length>110?this.screentowdata[index].basicRoundup.substring(0,110)+"...":this.screentowdata[index].basicRoundup;
          }else {
            this.content = this.screentowdata[index].basicRoundup.length>200?this.screentowdata[index].basicRoundup.substring(0,200)+"...":this.screentowdata[index].basicRoundup;

          }
          this.img = this.screentowdata[index].basicThumbnail;
          this.id = this.screentowdata[index].basicId
        }
      },
      handleHerf(id) {
        var pathurl
        if(id){
          pathurl = `/Details/${id}`
        }else {
          pathurl = `/Details/${this.id}`
        }
        //直接调用$router.push 实现携带参数的跳转
        let routefour = this.$router.resolve({
          path: pathurl
        });
        window.open(routefour.href, '_blank');
      },
    }
  }
</script>

<style scoped>
  @media screen and (max-width:1366px) {
    .resistance-character{
      height: 395px !important;
    }
    .zsjjzj {
       font-size: 45px !important;
     }
    .resistance-content-img-text{
      position: relative;
      font-size: 24px !important;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .button-next, .button-prev {
      width: 70px;
      height: 285px !important;
      cursor: pointer;
    }
    .resistance-content-right h3{
      font-size: 30px !important;
    }
    .resistance-content-right p {
      position: relative;
      font-size: 24px !important;
      height: 190px !important;
      line-height: 38px !important;
    }
    .resistance-content-right span {
      font-size: 28px !important;
    }
    .resistance-content-text {
      height: 100px !important;
      font-size: 22px !important;
    }
    .resistance-content-text.cont  {
      font-size: 24px !important;
      overflow: hidden;
      line-height: 35px !important;
    }


    .swiper-slide-title > p{
      font-size: 24px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .zsjjzj {
    width: 1306px;
    text-align: left;
    margin-bottom: 15px;
    color: red;
    font-size: 45px;
  }

  .swiper-pagination {
    position: absolute;
    display: flex;
    max-width: 130px;
    justify-content: right;
    left: 500px !important;
    bottom: 18px !important;
    z-index: 100000;
  }


  .swiper-pagination>>>span.swiper-pagination-bullet {
    width: 15px !important;
    height: 15px !important;
    margin-right: 5px !important;
    opacity: 5 !important;


  }

  .button-next, .button-prev {
    width: 70px;
    height: 265px;
    cursor: pointer;
  }

  .resistance-content > .swiper-container {
    width: 100%;
  }

  .swiper-container {
    position: relative;
    width: 629px;
    height: 388px;
  }

  .resistance-content-img-text {
    position: absolute;
    left: 0;
    bottom: 0px;
    height: 50px;
    text-align: left;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    font-size: 16px;
    color: white;
    padding: 0 15px !important;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .resistance-right {
    padding: 20px;
    box-sizing: border-box;
    width: 657px;
    height: 388px;
    margin-left: 20px;
    background-color: rgba(242, 242, 242, 1);
  }

  .resistance-content-right {
    position: relative;
    float: left;
    text-align: left;
    width: 100%;
    height: 100%;
  }

  .resistance-content-right h3 {
    font-weight: 900;
    font-size: 30px;
    color: #aa0000;
    margin-bottom: 26px;
  }

  .resistance-content-right p {
    width: 100%;
    height: 251px;
    margin-left: 10px;
    font-family: FZLTXHK--GBK1-0;
    font-size: 16px;
    line-height: 32px;
    color: #000000;
    overflow: hidden;
  }

  .resistance-content-right span {
    position: absolute;
    right: 0;
    /*bottom: -24px;*/
    bottom: 0px;
    display: block;
   padding: 3px 8px;
    background-color: #6f4326;
    border-radius: 8px;
    color: #ffffff;
    line-height: 33px;
    font-size: 20px;
    text-align: center;
    cursor: pointer;
  }

  .resistance-content-right span:hover {
    color: #40A9FF;
  }

  .resistance-content-text {
    width: 100%;
    height: 80px;
    font-size: 14px;
    padding: 15px !important;
    line-height: 25px;
    box-sizing: border-box;
    text-align: left;
    background-color: rgba(242, 242, 242, 1);
    cursor: pointer;
  }

  .resistance-content-left {
    float: left;
    width: 296.7px !important;
    height: 301px;
    margin-left: 0px !important;
    margin-right: 0px !important;
    box-sizing: border-box;
  }

  .resistance-content-left > .resistance-content-img {
    position: relative;
    height: 183.3px;
    cursor: pointer;
  }

  .resistance-content-left > .resistance-content-img > img {
    width: 100%;
    height: 100%;
  }

  .resistance-content-left >
  .swiper-slide .swiper-slide-duplicate {
    width: 170px;
    height: 221px;
  }

  .resistance {
    height: 100%;
    text-align: center;
    box-sizing: border-box;
  }

  .content {
    width: 100%;
    height: 100%;
    margin-top: 80px;
  }

  .resistance-character {
    text-align: center;
    position: relative;
    margin-top: 22px;
    margin-bottom: 5px;
    height: 423px;
    display: flex;
    justify-content: center;

  }

  .button-prev {
    z-index: 10000;
    left: 0;
    background: url("../../../assets/img/left-icon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .button-next {
    z-index: 10000;
    right: 0;
    background: url("../../../assets/img/right-icon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .resistance-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 1306px;
    height: 301px;
  }

  .contentnr {
    width: 100%;
    float: left;
    min-width: 800px !important;
  }

  .top {
    position: relative;
    width: 100%;
    height: 226px;
  }

  .top > div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1382px;
    height: 193px;
    background: url("../../../assets/img/tophongqi.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 6px;
  }

  .enlarge.swiper-slide {
    cursor: pointer;
  }

  .enlarge.swiper-slide img {
    width: 100% !important;
    height: 100% !important;
    margin: 0 auto;
  }

  .swiper-container {
    margin: 0px !important;
  }

  /*.swiper-slide {
    width: 292px !important;
    height: 180px;
    cursor: pointer;
    position: relative;
  }*/
  .swiper-slide-title {
    padding-right: 130px;
    box-sizing: border-box;
    padding-left: 10px;
    display: flex;
    align-items: center;
    height: 50px;
    box-sizing: border-box;
    text-align: left;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
    margin: 0 auto;
  }

  .swiper-slide-title > p {
    font-size: 16px ;
    line-height: 20px;
    width: 100%;
    height: 100%;
    padding: 10px 20px !important;
    box-sizing: border-box;
    text-align: left;
    position: absolute;
    bottom: 0;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
  }

  .swiper-slide > img {
    width: 292px;
    height: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/components/resistance.vue